/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Zarządzanie WWW
 *
 * @export
 * @class Page
 * @extends {Fixes}
 */
import { Fixes } from "./Fixes.class";

export class Page extends Fixes {
	constructor(options) {
		super();
		var noop = function (){};
		var defaults = {
			DOMLoaded: false,
			pageLoaded: false,
			scrollingElement: $(window),
			isIntersectionObserver: ( !!window.IntersectionObserver === true )? true : false,
			bootstrap: {
				size: null,
				kind: null,
				orientation: null // horizontal / vertical
			},
			device: {
				isIOS: null,
				isAndroid: null,
				initialWidth: null,
				initialHeight: null,
				isIE: null
			},
			onDOMLoaded: noop,
			onPageLoaded: noop,
			onMatchMediaChange: noop,
			onScroll: noop,
			onResize: noop,
			onResizeTriggered: noop,
			onPopstate: noop
		};
		this.settings = $.extend({}, defaults, options);
		this.getInfo = {
			getPageUrl(){return window.location.href},
			getFullPageURL() {
				if ( location.hash == "" )
					return window.location.href
				else
					return window.location.href + window.location.hash;
			},
			getPageHash(){return window.location.hash},
			getReferrer(){return document.referrer},
			getPreviousSites(){return history.length},

			getBrowserName(){return navigator.appName},
			getBrowserEngine(){return navigator.product},
			getBrowserVersion(){return navigator.userAgent},
			getBrowserLanguage(){return navigator.language},
			getBrowserOnline(){return navigator.onLine},
			getBrowserPlatform(){return navigator.platform},
			checkJavaEnabled(){return navigator.javaEnabled()},
			checkCookiesEnabled(){return navigator.cookieEnabled},
			getBrowserCookies(){return document.cookie},
			getBrowserCookiesArray(){return decodeURIComponent(document.cookie.split(";"))},
			getBrowserStorage(){return localStorage},

			getScreenWidth(){return screen.width},
			getScreenHeight(){return screen.height},
			getScreenDocW(){return $('body').width()},
			getScreenDocH(){return $('body').height()},
			getScreenWinW(){return $(window).width()},
			getScreenWinH(){return $(window).height()},
			getScreenInnerW(){return innerWidth},
			getScreenInnerH(){return innerHeight},
			getScreenAvailW(){return screen.availWidth},
			getScreenAvailH(){return screen.availHeight},
			getScreenColorDepth(){return screen.colorDepth},
			getScreenPixelDepth(){return screen.pixelDepth},

			// position nie działa poprawnie i trzeba rozgryźć temat
			getPossitionLatitude(){return position.coords.latitude},
			getPossitionLongitude(){return position.coords.longitude},
			getPossitionAccuracy(){return position.coords.accuracy},
			getPossitionAltitude(){return position.coords.altitude},
			getPossitionAltitudeAccuracy(){return position.coords.altitudeAccuracy},
			getPossitionHeading(){return position.coords.heading},
			getPossitionSpeed(){return position.coords.speed},
			getPossitionTimestamp(){return position.timestamp}
		};
		//this.fixes = {
		//fixScrollPositionAfterElementShow: false, // wyjatek korygujacy dziwne zachowanie na androidzie, czyli nagly skok skrolla po spacer.show
		//fixNaviStuckedElement: false // wyjatek korygujacy scroll przegladarki przesuwajacy el. stucked pod pasek adresu
		//}
		this.resizeControlTimer;
		//this.IOSBounceTimer;
		// document READY
		$(function () {
			var that = this;
			that.settings.DOMLoaded = true;
			that.updateBodyTag();
			// wyjatki dla IOS
			if (that.settings.device.isIOS) {
				$('body').addClass('isIOS');
				//that.fixes.fixNaviStuckedElement = true;
				that.fixNaviStuckedElement = true;
				that.fixIOSBounce();
			}
			if (that.settings.device.isAndroid) {
				$('body').addClass('isAndroid');
				//that.fixes.fixScrollPositionAfterElementShow = true;
				that.fixScrollPositionAfterElementShow = true;
			}
			// obsługa scroll
			that.settings.scrollingElement.on('scroll', function () {
				that.scrollControl();
			});
			// obsługa resize
			$(window).on('resize', function () {
				clearTimeout(that.resizeControlTimer);
				that.settings.onResize.call();
				that.resizeControlTimer = setTimeout(function () {
					that.resizeControl();
				}, RESIZE_CONTROL_DELAY);
			});
			if ($('.imgToZoom').length > 0) {
				$('.imgToZoom').each(function (i, e) {
					toolsObj.initZoomImage($(e));
				});
			}
			that.settings.onDOMLoaded.call();
		}.bind(this));
		// window loaded
		$(window).on('load', function () {
			var that = this;
			that.settings.pageLoaded = true;
			that.settings.onPageLoaded.call();
		}.bind(this)).on('popstate', function (event) {
			var that = this;
			that.settings.onPopstate.call(event);
		}.bind(this));
		// media query
		this.media_sm = window.matchMedia('(min-width: 576px)');
		this.media_sm.addListener(function () {
			this.updateMatchMedia(1); // sm
		}.bind(this));
		this.media_md = window.matchMedia('(min-width: 768px)');
		this.media_md.addListener(function () {
			this.updateMatchMedia(2); // md
		}.bind(this));
		this.media_lg = window.matchMedia('(min-width: 992px)');
		this.media_lg.addListener(function () {
			this.updateMatchMedia(3); // lg
		}.bind(this));
		this.media_xl = window.matchMedia('(min-width: 1200px)');
		this.media_xl.addListener(function () {
			this.updateMatchMedia(4); // xl
		}.bind(this));

		this.init();
	}
	// ****************************************************************************************************
	// Inicjalizacja strony
	// ****************************************************************************************************
	init() {
		var that = this;
		that.settings.device.isIOS = that.checkIOS();
		that.settings.device.isAndroid = that.checkAndroid();
		that.settings.device.isIE = that.checkIE();
		that.initDefaultCookies();
		that.updateMatchMedia();
		that.scrollControl();

		that.initInfoAboutUser();
	}
	// ****************************************************************************************************
	// aktualizacja wg matchMedia
	// ****************************************************************************************************
	updateMatchMedia(viewSize) {
		var that = this;
		if (viewSize === undefined)
			if (that.media_xl.matches)
				viewSize = 4;
			else if (that.media_lg.matches)
				viewSize = 3;
			else if (that.media_md.matches)
				viewSize = 2;
			else if (that.media_sm.matches)
				viewSize = 1;
			else
				viewSize = 0;
		var actualViewSize = that.settings.bootstrap.size;
		if (actualViewSize == viewSize)
			viewSize -= 1;
		that.settings.bootstrap.size = viewSize;
		that.settings.device.initialHeight = $(window).height();
		that.settings.device.initialWidth = $(window).width();
		that.settings.bootstrap.orientation = ($(window).width() > that.settings.device.initialHeight) ? 'horizontal' : 'vertical';
		if (that.settings.DOMLoaded) {
			that.updateBodyTag(actualViewSize);
			that.settings.onMatchMediaChange.call();
		}
	}
	// ****************************************************************************************************
	// dekodowanie size bootsrap (z liczby na zapis tekstowy)
	// ****************************************************************************************************
	decodeBootsrapSize(i) {
		if (i == 4)
			return 'xl';
		if (i == 3)
			return 'lg';
		if (i == 2)
			return 'md';
		if (i == 1)
			return 'sm';
		return 'xs';
	}
	// ****************************************************************************************************
	// aktualizacja wg class w tagu body + bootstrap.kind
	// ****************************************************************************************************
	updateBodyTag(actualViewSize) {
		var that = this;
		if (actualViewSize === undefined)
			actualViewSize = 0;
		$('body').removeClass('view-' + that.decodeBootsrapSize(actualViewSize)).addClass('view-' + that.decodeBootsrapSize(that.settings.bootstrap.size));
		if (that.settings.bootstrap.size > 1) {
			$('body').removeClass('view-mobile').addClass('view-desktop');
			that.settings.bootstrap.kind = 'desktop';
		}
		else {
			$('body').removeClass('view-desktop').addClass('view-mobile');
			that.settings.bootstrap.kind = 'mobile';
		}
	}
	// ****************************************************************************************************
	// Aktualizacja wg scroll
	// ****************************************************************************************************
	scrollControl() {
		var that = this;
		//that.removeFixNaviStuckedElement();
		if (that.settings.DOMLoaded) {
			that.settings.onScroll.call();
		}
	}
	// ****************************************************************************************************
	// Aktualizacja wg resize
	// ****************************************************************************************************
	resizeControl() {
		var that = this;
		that.settings.onResizeTriggered.call();
	}
	// ****************************************************************************************************
	// Wykrycie rodzaju urządzenia
	// ****************************************************************************************************
	checkIOS() {
		return /(ipad|iphone|ipod)/g.test(navigator.userAgent.toLowerCase());
	}
	checkAndroid() {
		return /(android)/g.test(navigator.userAgent.toLowerCase());
	}
	checkIE() {
		var ua = window.navigator.userAgent;
		var msie = ua.indexOf("MSIE ");
		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer, return version number
		{
			this.addIEFix();
			return true;
		}
		return false;
	}
	// ****************************************************************************************************
	// Przesuniecie strony do wywołania stuck dla navi
	// ****************************************************************************************************
	scrollPageToNaviStuckState() {
		var that = this;

//		if ( typeof(stuckObj) !== undefined ) {
			var aboveElStuckHeight = $('#mobileLogo').height();
			if (aboveElStuckHeight > $(window).scrollTop()) {
				window.scrollTo(0, (aboveElStuckHeight + 2)); // 1 dla border top body i 1 dla przekroczenia granicy odpalania stuck
//				stuckObj.resize();
				if ($(window).scrollTop() > (aboveElStuckHeight + 2)) { // wyrownuje efekt znikania i pojawiania sie naglowka przegladarki np w adroidzie
					window.scrollTo(0, (aboveElStuckHeight + 2));
				}
			}
//		}

	}
	// ****************************************************************************************************
	// Przesuniecie strony do wywołania stuck dla navi
	// ****************************************************************************************************
	initDefaultCookies() {
		var that = this;
		var currentListingType = (toolsObj.getCookie('productsListingStyle') == 'boxes' || toolsObj.getCookie('productsListingStyle') == 'lines') ? toolsObj.getCookie('productsListingStyle') : 'boxes';
		toolsObj.setCookie('productsListingStyle', currentListingType, 365); // refresh cookie
	}

	// ****************************************************************************************************
	// Scrolowanie do wskazanego ID - element klasy hashLink
	// ****************************************************************************************************
	initScrollToHash() { // inna wersja : TOOLS -> initScrollTo
		var that = this;
		$('.hashLink').each(function (i, e) {
			$(e).on('click', function () {
				var url = $(this).attr('href');
				var hash = url.substring(url.indexOf('#') + 1);
				if ($('#' + hash).length > 0) {
					that.animateScrollToHash('#' + hash, EFFECTS_SPEED);
				}
			});
		});
	}

	// ****************************************************************************************************
	// Korekta automatycznego scrolla z przeglądarki (korekta o wysokość przyklejonego menu)
	// ****************************************************************************************************
	fixAutoScrollToHash() {
		var that = this;
		var hash = window.location.hash;

		if ( hash.includes('#/') ) // wylapanie: Syntax error, unrecognized expression: #/
			return false;

		if ( hash.includes('?') ) // wyluskanie hasha z niepoprawnego zapisu: #hash?parametr=xxx
			hash = hash.split('?')[0];

		if ( $(hash).length > 0 ) {
			that.animateScrollToHash(hash, 0);
		}
	}

	// ****************************************************************************************************
	// scroll strony do hasha
	// ****************************************************************************************************
	animateScrollToHash(hash, durration) {
		var offsetTop = $(hash).offset().top - $('#navi').height() - 20;
		$('html, body').animate({
			scrollTop: offsetTop
		}, durration);
	}

	// ****************************************************************************************************
	// informacje któ®e da się wyciągnąć z JS o użytkowniku
	// ****************************************************************************************************
	initInfoAboutUser() {
		let that = this;
		let timezone = (new Date()).getTimezoneOffset()/60;
		let timeOpened = new Date(Date.now() - (timezone*60*60*1000));

		that.info = {
			timezone: timezone+ 'h',
			timeOpened: timeOpened.toISOString().split('.')[0].replace('T',' '),

			pageUrl: that.getInfo.getPageUrl(),
			pageHash: that.getInfo.getPageHash(),
			refferer: that.getInfo.getReferrer(),
			previousSites: that.getInfo.getPreviousSites(),

			browser: {
				name: that.getInfo.getBrowserName(),
				ingine: that.getInfo.getBrowserEngine(),
				version: that.getInfo.getBrowserVersion(),
				language: that.getInfo.getBrowserLanguage(),
				online: that.getInfo.getBrowserOnline(),
				platform: that.getInfo.getBrowserPlatform(),
				isJavaEnabled: that.getInfo.checkJavaEnabled(),
				isCookiesEnabled: that.getInfo.checkCookiesEnabled()
			},

			screen: {
				resolutionW: that.getInfo.getScreenWidth(),
				resolutionH: that.getInfo.getScreenHeight(),
				docW: that.getInfo.getScreenDocW(),
				docH: that.getInfo.getScreenDocH(),
				winW: that.getInfo.getScreenWinW(),
				winH: that.getInfo.getScreenWinH(),
				innerW: that.getInfo.getScreenInnerW(),
				innerH: that.getInfo.getScreenInnerH(),
				availW: that.getInfo.getScreenAvailW(),
				availH: that.getInfo.getScreenAvailH(),
				colorDepth: that.getInfo.getScreenColorDepth(),
				pixelDepth: that.getInfo.getScreenPixelDepth()
			}
			/*,

			possition: {
				latitude: that.getInfo.getPossitionLatitude(),
				longitude: that.getInfo.getPossitionLongitude(),
				accuracy: that.getInfo.getPossitionAccuracy(),
				altitude: that.getInfo.getPossitionAltitude(),
				altitudeAccuracy: that.getInfo.getPossitionAltitudeAccuracy(),
				heading: that.getInfo.getPossitionHeading(),
				speed: that.getInfo.getPossitionSpeed(),
				timestamp: that.getInfo.getPossitionTimestamp()
			}*/
		};
	}

	// ****************************************************************************************************
	// update info o elementy które się żle ustawiają podczas inicjacji
	// ****************************************************************************************************
	updateInfoAfterPageLoaded() {
		let that = this;

		that.info.screen.docW = that.getInfo.getScreenDocW(),
		that.info.screen.docH = that.getInfo.getScreenDocH(),
		that.info.screen.winW = that.getInfo.getScreenWinW(),
		that.info.screen.winH = that.getInfo.getScreenWinH()
	}

	// ****************************************************************************************************
	// update info o elementy które się żle ustawiają podczas inicjacji
	// ****************************************************************************************************
	reorganizeProductPage() {
		let that = this;
		if ( that.settings.bootstrap.kind == 'mobile' ) {
			that.reorganizeProductPageForMobile();
		} else {
			that.reorganizeProductPageForDesktop();
		}
	}

	// ****************************************************************************************************
	// update info o elementy które się żle ustawiają podczas inicjacji
	// ****************************************************************************************************
	reorganizeProductPageForMobile() {
		let that = this;

		//$(".rightProductPanel > .row").removeClass("sticky-top");

		$("#imgBox").insertAfter(".productPanelInfo h1");//.prependTo(".rightProductPanel > .row");

		$(".leftProductPanel .product-menu").appendTo(".leftProductPanel");
	}

	// ****************************************************************************************************
	// update info o elementy które się żle ustawiają podczas inicjacji
	// ****************************************************************************************************
	reorganizeProductPageForDesktop() {
		let that = this;

		//$(".rightProductPanel > .row").addClass("sticky-top");
		$("#imgBox").prependTo(".leftProductPanel");
		$(".leftProductPanel .product-menu").prependTo(".leftProductPanel");
	}
}